import { LOGO_URL } from "./site";

// Canonical production origin used for canonical/OG URLs and sitemap.
export const SITE_URL = "https://digsbyearlylearning.com";
export const SITE_NAME = "Digsby Early Learning";
// Default branded share image (absolute URL required for OG/Twitter crawlers).
export const DEFAULT_OG_IMAGE = SITE_URL + LOGO_URL;

// Build an absolute canonical URL from a route path (strips query/hash).
export function canonicalUrl(pathname) {
  const clean = (pathname || "/").split("?")[0].split("#")[0];
  return SITE_URL + (clean === "/" ? "/" : clean.replace(/\/$/, ""));
}
